import { render } from "./InfoRowPromReport.vue?vue&type=template&id=dfb0e4d0"
import script from "./InfoRowPromReport.vue?vue&type=script&lang=js"
export * from "./InfoRowPromReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__